import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// components
import Sidebar from "components/Sidebar/Sidebar.js";
import CardFullTable from "components/Cards/Admin/CardFullTable.js";
// texts as props
import sidebar from "_texts/admin/sidebar/sidebar.js";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, clearSavedUser } from "actions/users";

export const Users = () => {
  const location = useLocation();
  const users = useSelector((state) => state.users.users);
  const dispatch = useDispatch();
  const [body, setBody] = useState([]);
  const [head, setHead] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    console.log("!!! BODY: ", body);
  }, [body]);

  useEffect(() => {
    if (users.length === 0) {
      dispatch(getUsers());
    } else {
      console.log("!!! USER LENGTH: ", users.length);
      const keys = [
        "id",
        "public_id",
        "email",
        "first_name",
        "last_name",
        "user_type",
      ];
      setHead(keys);
      const newBody = users.map((user) => {
        console.log("!!! USER: ", user);
        const values = [
          user.id,
          user.public_id,
          user.email ?? "",
          user.firstname ?? "",
          user.lastname ?? "",
          user.user_type ?? "",
        ];
        return values;
      });
      console.log("!!! NEW BODY: ", newBody);
      setBody(newBody);
    }

    console.log("!!! USERS: ", users.length, users);
  }, [users, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const editUser = (row) => {
    const user = {};
    head.forEach((key, index) => {
      user[key] = row[index];
    });
    console.log("EDIT USER: ", user);
    navigate(`/admin/user/${user.public_id}`);
  };

  return (
    <>
      <Sidebar {...sidebar} />
      <div
        className="relative md:ml-64 bg-blueGray-100 pt-24"
        style={{ height: "100%", minHeight: "100vh" }}
      >
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-24">
          <div className="flex flex-wrap">
            <div className="w-full px-4">
              <CardFullTable
                title="Users"
                titlebutton={
                  <i
                    onClick={() => {
                      dispatch(clearSavedUser());
                      navigate("/admin/user");
                    }}
                    className="fa fa-user-plus text-sm cursor-pointer"
                  />
                }
                head={head ?? []}
                body={body ?? []}
                color="white"
                onRowClick={(row) => editUser(row)}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Users;
